import { ApprovalRequestCategory } from '@/api/types/approvalRequests';
import { ApprovalRequestsTabsPage } from './ApprovalRequestsTabsPage';

export function MatchingEngineRequestsPage({ initialTab }: { initialTab: 'requests' | 'history' }) {
  return (
    <ApprovalRequestsTabsPage
      category={ApprovalRequestCategory.MatchingEngine}
      title="Matching Engine Requests"
      scope="me"
      basePath="/User/DailyReconciliation/MatchingEngineRequests"
      viewRequestsPermission="User.SafeguardingReconciliation.MatchingEngineRequests.Requests"
      viewHistoryPermission="User.SafeguardingReconciliation.MatchingEngineRequests.History"
      approveRejectPermission="User.SafeguardingReconciliation.MatchingEngine.ApproveReject"
      initialTab={initialTab}
    />
  );
}
